import { useCallback, useEffect } from "react";
import { useFormContext } from "../../../common/contexts/FormContext";
import { sessionStorageUtils } from "../../../utility/utility";

interface UserDetails {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  zipcode?: string;
  address?: string;
}

const STORAGE_KEY = "cs-userDetails";
const URL_PARAM = "userDetails";

export const useUserDetailsFromUrl = () => {
  const { setFormValues } = useFormContext();
  const getUserDetailsSource = useCallback((): string | null => {
    try {
      const urlParams = new URLSearchParams(globalThis.location?.search || "");
      const urlUserDetails = urlParams.get(URL_PARAM);

      if (urlUserDetails?.trim()) {
        return urlUserDetails;
      }
      const storageUserDetails = sessionStorageUtils.getItem(STORAGE_KEY);
      return storageUserDetails?.trim() || null;
    } catch (error) {
      console.error("Error accessing user details source:", error);
      return null;
    }
  }, [STORAGE_KEY, URL_PARAM]);

  useEffect(() => {
    const extractAndSetUserDetails = () => {
      try {
        const encodedUserDetails = getUserDetailsSource();
        if (!encodedUserDetails) {
          return;
        }
        const decodedString = decodeURIComponent(encodedUserDetails);
        const jsonString = atob(decodedString);
        const userData: UserDetails = JSON.parse(jsonString);

        setFormValues((prevValues) => ({
          ...prevValues,
          ...(userData.firstName && { fname: userData.firstName }),
          ...(userData.lastName && { lname: userData.lastName }),
          ...(userData.email && { email: userData.email }),
          ...(userData.phone && { phone: userData.phone }),
          ...(userData.zipcode && { zipcode: userData.zipcode }),
          ...(userData.address && { address: userData.address }),
        }));
      } catch (err) {
        console.error("Failed to decode user details from URL:", err);
      }
    };

    extractAndSetUserDetails();
  }, [setFormValues]);
};
